// path.ts

// Action Types
export const SET_PREVIOUS_PATH = 'SET_PREVIOUS_PATH';

// Action Interfaces
interface SetPreviousPathAction {
    type: typeof SET_PREVIOUS_PATH;
    payload: string;
}

export type PathActionTypes = SetPreviousPathAction;

// Action Creators
export const setPreviousPath = (path: string): PathActionTypes => ({
    type: SET_PREVIOUS_PATH,
    payload: path
});
